import { useDroppable } from '@dnd-kit/core';
import { Methodology } from './Methodology';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

export const MethodologyContainer = ({items, id, title}) => {
    const { t } = useTranslation()

    const {setNodeRef} = useDroppable({id})

    return(
        <SortableContext items={items} id={id} strategy={verticalListSortingStrategy}>
            <Col xs={12}>
                <h5>{t('profile.candidate.' + title)}</h5>
                <div className='dragdrop' ref={setNodeRef}>
                    {
                        items.map((methodology) => (
                            <Methodology key={methodology?.id || new Date().getTime()} methodology={methodology}/>
                        ))
                    }
                </div>
            </Col>
        </SortableContext>
    )
}